import { EMPTY_OBJECT } from '../../../constants/common'
import { SearchItem } from '../../Search'

import { FLAT_SEARCH_ITEM_ICON } from './FlatSearchItem.constants'

import * as styles from './FlatSearchItem.module.css'

function FlatSearchItem({ className = styles.FlatSearchItem, value }) {
  const { address, archived, number } = value.item ?? EMPTY_OBJECT

  const additional = [address]

  return (
    <SearchItem
      additional={additional}
      archived={archived}
      className={className}
      icon={FLAT_SEARCH_ITEM_ICON}
      title={number}
    />
  )
}

export default FlatSearchItem
